import React, { useEffect } from 'react';
import "./App.css"
import { HashRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Main from './components/Main/Main';
import ErrorPage from './components/ErrorPage/ErrorPage';

import "react-datepicker/dist/react-datepicker.css";
import "react-multi-email/dist/style.css";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Loader from './components/Common/Loader/Loader';

import { TokenParseAPI } from './components/Auth/Login';
import { SecretKey, set } from './components/Encryption/EncryptDecrypt';
import { Url } from './constants/ApiUrlConstants';
import Proxy from './components/Auth/Proxy';

const App = () => {
  

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={sessionStorage.getItem('TOKEN') ? <Navigate to={'/main'} /> : <Navigate to={'/login'} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/proxy" element={<Proxy />} />
        <Route path="/main/*" element={<Main />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
      <Loader />
    </HashRouter>
  )
}


export default App;